import styled from "styled-components";
import {COLORS} from "shared/consts";

export const UnionButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 0 16px;
   
    color: ${COLORS.FG.DEFAULT};
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    cursor: pointer;
    user-select: none;
    transition: opacity 0.2s ease, box-shadow 0.2s ease;
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        box-shadow: none;
    }
`;